export const align = 'center';

export const internationalColumns = [
  {
    title: '柜号',
    dataIndex: 'cntr_no',
    key: 'cntr_no',
    align,
    width: 120
  },
  {
    title: '商品名称',
    dataIndex: 'prod_name',
    key: 'prod_name',
    align,
    width: 120
  },
  {
    title: '规格',
    dataIndex: 'prod_norms',
    key: 'prod_norms',
    align,
    width: 120
  },
  {
    title: '数量',
    dataIndex: 'prod_num',
    key: 'prod_num',
    align,
    width: 120
  },
  // {
  //   title: '出发温度',
  //   dataIndex: 'depart_temp',
  //   key: 'depart_temp',
  //   align
  // },
  // {
  //   title: '到达温度',
  //   dataIndex: 'arrive_temp',
  //   key: 'arrive_temp',
  //   align
  // }
];

export const nationalColumns = [
  {
    title: '司机',
    dataIndex: 'driver',
    key: 'driver',
    align,
    width: 120
  },
  {
    title: '电话',
    dataIndex: 'mobile',
    key: 'mobile',
    align,
    width: 120
  },
  {
    title: '车型',
    dataIndex: 'model',
    key: 'model',
    align,
    width: 120
  },
  // {
  //   title: '货柜温度',
  //   dataIndex: 'temperature',
  //   key: 'temperature',
  //   align,
  //   width: 120
  // },
  {
    title: '车辆状态',
    dataIndex: 'trans_status',
    key: 'trans_status',
    align,
    width: 120
  }
];

export const nationalColumnsProducts = [
  // {
  //   title: '中国柜号',
  //   dataIndex: 'cn_cntr_no',
  //   key: 'cn_cntr_no',
  //   align,
  //   width: 120
  // },
  {
    title: '泰国柜号',
    dataIndex: 'th_cntr_no',
    key: 'th_cntr_no',
    align,
    width: 120
  },
  {
    title: '商品名称',
    dataIndex: 'prod_name',
    key: 'prod_name',
    align,
    width: 120
  },
  {
    title: '规格',
    dataIndex: 'prod_norms',
    key: 'prod_norms',
    align,
    width: 120
  },
  {
    title: '数量',
    dataIndex: 'prod_num',
    key: 'prod_num',
    align,
    width: 120
  }
];

export const historyColumns=[
  {
    title: '运单号',
    dataIndex: 'transport_no',
    key: 'transport_no',
    align,
  },
  {
    title: '运输方式',
    dataIndex: 'trans_status',
    key: 'trans_status',
    align,
  },
  {
    title: '柜号',
    dataIndex: 'cntr_no',
    key: 'cntr_no',
    align,
  },
  {
    title: '出发时间',
    dataIndex: 'depart_at',
    key: 'depart_at',
    align,
  },
  {
    title: '出发地点',
    dataIndex: 'depart_name',
    key: 'depart_name',
    align,
  },
  {
    title: '出发温度',
    dataIndex: 'depart_temp',
    key: 'depart_temp',
    align,
  },
  {
    title: '到达时间',
    dataIndex: 'arrive_at',
    key: 'arrive_at',
    align,
  },
  {
    title: '到达地点',
    dataIndex: 'arrive_name',
    key: 'arrive_name',
    align,
  },
  {
    title: '到达温度',
    dataIndex: 'arrive_temp',
    key: 'arrive_temp',
    align,
  },
];

// 柜号 运输方式 运单号 商品名称 数量 出发时间 出发地点 出发温度 到达时间 到达地点 到达温度 状态
export const historyColumn=[
  {
    title: '柜号',
    dataIndex: 'cntr_no',
    key: 'cntr_no',
    align,
  },
  {
    title: '运输方式',
    dataIndex: 'trans_type',
    key: 'trans_type',
    align,
  },
  {
    title: '运单号',
    dataIndex: 'transport_no',
    key: 'transport_no',
    align,
  },
  {
    title: '商品名称',
    dataIndex: 'prod_name',
    key: 'prod_name',
    align,
  },
  {
    title: '数量',
    dataIndex: 'prod_num',
    key: 'prod_num',
    align,
  },
  {
    title: '出发时间',
    dataIndex: 'depart_at',
    key: 'depart_at',
    align,
  },
  {
    title: '出发地点',
    dataIndex: 'depart_name',
    key: 'depart_name',
    align,
  },
  {
    title: '出发温度',
    dataIndex: 'depart_temp',
    key: 'depart_temp',
    align,
  },
  {
    title: '到达时间',
    dataIndex: 'arrive_at',
    key: 'arrive_at',
    align,
  },
  {
    title: '到达地点',
    dataIndex: 'arrive_name',
    key: 'arrive_name',
    align,
  },
  {
    title: '到达温度',
    dataIndex: 'arrive_temp',
    key: 'arrive_temp',
    align,
  },
  {
    title: '状态',
    dataIndex: 'trans_status',
    key: 'trans_status',
    align,
  },
];

export const base_product_list_columns =[
  {
    title: '商品名称',
    dataIndex: 'prod_name',
    key: 'prod_name',
    align,
    width: 120
  },
  {
    title: '商品编码',
    dataIndex: 'prod_code',
    key: 'prod_code',
    align,
    width: 120
  },
  {
    title: '规格',
    dataIndex: 'prod_norms',
    key: 'prod_norms',
    align,
    width: 120
  },
  {
    title: '数量',
    dataIndex: 'prod_num',
    key: 'prod_num',
    align,
    width: 120
  }
];